import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    accidenteLaboral: [],
  },

  getters: {
    getAccidenteLaboral: (state) => state.accidenteLaboral,
  },

  mutations: {
    SET_ACCIDENTE_LABORAL(state, accidenteLaboral) {
      state.accidenteLaboral = accidenteLaboral;
    },
  },

  actions: {
    async fetchAccidenteLaboral({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/accidenteLaboral`)
        .then((response) => {
          commit('SET_ACCIDENTE_LABORAL', response.data.data);
        });
    },

    async saveAccidenteLaboral(context, accidenteLaboral) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;
      await axios
        .post(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/accidenteLaboral`, accidenteLaboral);
    },

    async updateAccidenteLaboral(_, accidenteLaboral) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/historiaClinica/${
            accidenteLaboral.fk_idHistoriaClinica
          }/accidenteLaboral/${
            accidenteLaboral.fk_idAccidenteLaboral}`,
          accidenteLaboral,
        );
    },
  },
};
